// // import React, { useState, useEffect, useMemo } from 'react';
// // import { MapPin, User, Video, X, ChevronDown, Star } from 'lucide-react';
// // import './AuditionDashbord.css'; // Make sure this points to your CSS file

// // // List of cities to show explicitly. All others go to "Other"
// // const MAIN_CITIES = [
// //   'Mumbai', 'Pune', 'Delhi', 'Bangalore', 
// //   'Nagpur', 'Nashik', 'Ahilyanagar', 'Sambhajinagar', 'Thane'
// // ];

// // export default function AuditionDashboard() {
// //   // --- STATE ---
// //   const [candidates, setCandidates] = useState([]); 
// //   const [visibleCount, setVisibleCount] = useState(20); 
// //   const [selectedCandidate, setSelectedCandidate] = useState(null); 

// //   // Filter State
// //   const [filters, setFilters] = useState({
// //     categories: [],
// //     genders: [], // Added Gender
// //     productionTypes: [],
// //     cities: [],
// //     ageMin: 0,
// //     ageMax: 100
// //   });

// //   // --- INITIAL LOAD ---
// //   useEffect(() => {
// //     const fetchCandidates = async () => {
// //       try {
// //         const API_URL = "https://fs1w4qkflb.execute-api.ap-south-1.amazonaws.com/proud/accessaudtions";
// //         const S3_BASE_URL = "https://auditionsww.s3.ap-south-1.amazonaws.com/";

// //         const response = await fetch(API_URL);
// //         const data = await response.json();

// //         const formattedData = data.map(item => ({
// //           id: item.auditionId, 
// //           fullName: item.fullName,
// //           age: Number(item.age),
// //           gender: item.gender || 'Other', // Handle missing gender
// //           category: item.category,
// //           productionType: item.productionType,
// //           city: item.city,
// //           experience: item.experience,
// //           roleDescription: item.roleDescription,
// //           contactNo: item.contactNo,
// //           email: item.email,
// //           youtubeLink: item.youtubeLink,
// //           // Social media might be in item.socialMedia if you added it in the form
// //           images: item.imageUrls ? item.imageUrls.map(key => S3_BASE_URL + key) : []
// //         }));

// //         setCandidates(formattedData);
// //       } catch (error) {
// //         console.error("Error fetching data:", error);
// //       }
// //     };

// //     fetchCandidates();
// //   }, []);

// //   // --- HELPER: NORMALIZE CITY ---
// //   // Returns specific city name if in list, otherwise "Other"
// //   const getDisplayCity = (city) => {
// //     if (!city) return 'Other';
// //     const normalized = city.trim();
// //     // Case insensitive check could be added here if needed
// //     return MAIN_CITIES.includes(normalized) ? normalized : 'Other';
// //   };

// //   // --- FILTERING LOGIC ---
// //   const filteredCandidates = useMemo(() => {
// //     return candidates.filter(candidate => {
      
// //       // 1. Category Filter
// //       if (filters.categories.length > 0 && !filters.categories.includes(candidate.category)) return false;
      
// //       // 2. Gender Filter (NEW)
// //       if (filters.genders.length > 0 && !filters.genders.includes(candidate.gender)) return false;

// //       // 3. Production Type Filter
// //       if (filters.productionTypes.length > 0) {
// //         // If candidate has a custom type not in the main list, you might want to group it as 'Other'
// //         // For now, simple inclusion:
// //         if (!filters.productionTypes.includes(candidate.productionType)) return false;
// //       }
      
// //       // 4. City Filter (With "Other" Logic)
// //       if (filters.cities.length > 0) {
// //         const group = getDisplayCity(candidate.city);
// //         if (!filters.cities.includes(group)) return false;
// //       }
      
// //       // 5. Age Filter
// //       if (candidate.age < filters.ageMin || candidate.age > filters.ageMax) return false;

// //       return true;
// //     });
// //   }, [candidates, filters]);

// //   // --- LAZY LOADING ---
// //   // --- LAZY LOADING ---
// //   useEffect(() => {
// //     const handleScroll = () => {
// //       if (
// //         window.innerHeight + document.documentElement.scrollTop >=
// //         document.documentElement.offsetHeight - 100
// //       ) {
// //         setVisibleCount(prev => Math.min(prev + 20, filteredCandidates.length));
// //       }
// //     };

// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, [filteredCandidates.length]);

// // //   const handleScroll = () => {
// // //     if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
// // //       setVisibleCount(prev => Math.min(prev + 20, filteredCandidates.length));
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     window.addEventListener('scroll', handleScroll);
// // //     return () => window.removeEventListener('scroll', handleScroll);
// // //   }, [filteredCandidates]);

// //   // --- HANDLERS ---
// //   const toggleFilter = (type, value) => {
// //     setFilters(prev => {
// //       const list = prev[type];
// //       const newList = list.includes(value) 
// //         ? list.filter(item => item !== value) 
// //         : [...list, value]; 
// //       return { ...prev, [type]: newList };
// //     });
// //   };

// //   // --- REUSABLE CHECKBOX COMPONENT ---
// //   const CheckboxGroup = ({ title, options, type, currentSelected, countAccessor }) => (
// //     <div className="filter-group">
// //       <h4>{title}</h4>
// //       {options.map(opt => {
// //         // Calculate Count dynamically based on the accessor logic
// //         const count = candidates.filter(c => countAccessor(c) === opt).length;
        
// //         return (
// //           <label key={opt} className="checkbox-label">
// //             <input 
// //               type="checkbox" 
// //               checked={currentSelected.includes(opt)}
// //               onChange={() => toggleFilter(type, opt)}
// //             />
// //             <span>{opt}</span>
// //             <span className="count">({count})</span>
// //           </label>
// //         );
// //       })}
// //     </div>
// //   );

// //   return (
// //     <div className="dashboard-container">
// //       {/* HEADER */}
// //       <header className="dashboard-header">
// //         <div className="header-content">
// //           <h1>Audition Talent Pool</h1>
// //           <p>{filteredCandidates.length} profiles found matching your criteria</p>
// //         </div>
// //       </header>

// //       <div className="layout-grid">
        
// //         {/* LEFT SIDEBAR: FILTERS */}
// //         <aside className="sidebar">
// //           <div className="filter-card">
// //             <div className="filter-header">
// //               <h3>Filter by:</h3>
// //             </div>
            
// //             {/* Category */}
// //             <CheckboxGroup 
// //               title="Category" 
// //               options={['Actor', 'Model', 'Dancer', 'Singer', 'Voice Artist']} 
// //               type="categories"
// //               currentSelected={filters.categories}
// //               countAccessor={(c) => c.category}
// //             />

// //             {/* Gender (NEW) */}
// //             <CheckboxGroup 
// //               title="Gender" 
// //               options={['Male', 'Female', 'Other']} 
// //               type="genders"
// //               currentSelected={filters.genders}
// //               countAccessor={(c) => c.gender}
// //             />

// //             {/* City (Updated with specific list + Other) */}
// //             <CheckboxGroup 
// //               title="Current City" 
// //               options={[...MAIN_CITIES, 'Other']} 
// //               type="cities"
// //               currentSelected={filters.cities}
// //               countAccessor={(c) => getDisplayCity(c.city)} // Use helper for count
// //             />

// //             {/* Interested In (Added 'Other') */}
// //             <CheckboxGroup 
// //               title="Interested In" 
// //               options={['Film', 'TV Commercial (Ad)', 'Web Series', 'Theatre', 'Short Film', 'Other']} 
// //               type="productionTypes"
// //               currentSelected={filters.productionTypes}
// //               countAccessor={(c) => c.productionType}
// //             />

// //             {/* Age Range */}
// //             <div className="filter-group">
// //               <h4>Age Range</h4>
// //               <div className="range-inputs">
// //                 <input 
// //                   type="number" 
// //                   value={filters.ageMin} 
// //                   onChange={(e) => setFilters(prev => ({...prev, ageMin: Number(e.target.value)}))}
// //                   placeholder="Min"
// //                 />
// //                 <span>-</span>
// //                 <input 
// //                   type="number" 
// //                   value={filters.ageMax} 
// //                   onChange={(e) => setFilters(prev => ({...prev, ageMax: Number(e.target.value)}))}
// //                   placeholder="Max"
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         </aside>

// //         {/* MAIN CONTENT: CANDIDATE CARDS */}
// //         <main className="results-area">
// //           {filteredCandidates.length === 0 ? (
// //             <div className="no-results">
// //               <h3>No candidates found.</h3>
// //               <p>Try adjusting your filters.</p>
// //             </div>
// //           ) : (
// //             filteredCandidates.slice(0, visibleCount).map(candidate => (
// //               <div key={candidate.id} className="candidate-card" onClick={() => setSelectedCandidate(candidate)}>
                
// //                 {/* Left: Image */}
// //                 <div className="card-image-wrapper">
// //                   <img 
// //                     src={candidate.images[0] || "https://via.placeholder.com/200?text=No+Image"} 
// //                     alt={candidate.fullName} 
// //                   />
// //                 </div>

// //                 {/* Middle: Info */}
// //                 <div className="card-info">
// //                   <div className="card-header">
// //                     <div>
// //                       <h2>{candidate.fullName}</h2>
// //                       <div className="sub-header">
// //                         <span className={`badge ${candidate.category.toLowerCase().split(' ')[0]}`}>{candidate.category}</span>
// //                         <span className="gender-text">• {candidate.gender}</span>
// //                       </div>
// //                     </div>
// //                   </div>
                  
// //                   <div className="card-meta">
// //                     <span className="meta-item"><User size={16} /> {candidate.age} yrs</span>
// //                     <span className="meta-item"><MapPin size={16} /> {candidate.city}</span>
// //                     <span className="meta-item"><Star size={16} /> {candidate.experience}</span>
// //                   </div>

// //                   <p className="card-desc">
// //                     {candidate.roleDescription && candidate.roleDescription.length > 100 
// //                       ? candidate.roleDescription.substring(0, 100) + "..." 
// //                       : candidate.roleDescription}
// //                   </p>
// //                 </div>

// //                 {/* Right: Actions */}
// //                 <div className="card-actions">
// //                   <div className="score-box">
// //                     <span>New</span>
// //                   </div>
// //                   <div className="price-dummy">
// //                     <small>Interested in</small>
// //                     <span style={{fontSize:'0.9rem'}}>{candidate.productionType}</span>
// //                   </div>
// //                   <button className="view-btn">
// //                     Details <ChevronDown size={16} />
// //                   </button>
// //                 </div>
// //               </div>
// //             ))
// //           )}
          
// //           {visibleCount < filteredCandidates.length && (
// //             <div className="loading-indicator">Loading more profiles...</div>
// //           )}
// //         </main>
// //       </div>

// //       {/* MODAL POPUP */}
// //       {selectedCandidate && (
// //         <div className="modal-overlay" onClick={() => setSelectedCandidate(null)}>
// //           <div className="modal-content" onClick={e => e.stopPropagation()}>
// //             <button className="close-btn" onClick={() => setSelectedCandidate(null)}><X size={24}/></button>
            
// //             <div className="modal-header">
// //               <h2>{selectedCandidate.fullName}</h2>
// //               <p>{selectedCandidate.category} • {selectedCandidate.gender} • {selectedCandidate.city}</p>
// //             </div>

// //             <div className="modal-body">
// //               <div className="modal-gallery">
// //                 {selectedCandidate.images.map((img, idx) => (
// //                   <img key={idx} src={img} alt={`Gallery ${idx}`} />
// //                 ))}
// //               </div>

// //               <div className="modal-details">
// //                 <div className="detail-grid">
// //                     <div className="detail-row"><strong>Age:</strong> {selectedCandidate.age}</div>
// //                     <div className="detail-row"><strong>Contact:</strong> {selectedCandidate.contactNo}</div>
// //                     <div className="detail-row"><strong>Email:</strong> {selectedCandidate.email}</div>
// //                     <div className="detail-row"><strong>Experience:</strong> {selectedCandidate.experience}</div>
// //                 </div>

// //                 <div className="detail-block">
// //                   <strong>Role Description / About:</strong>
// //                   <p>{selectedCandidate.roleDescription}</p>
// //                 </div>

// //                 {selectedCandidate.youtubeLink && (
// //                   <a href={selectedCandidate.youtubeLink} target="_blank" rel="noreferrer" className="youtube-btn">
// //                     <Video size={18} /> Watch Audition Tape
// //                   </a>
// //                 )}
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }

// import React, { useState, useEffect, useMemo } from 'react';
// import { MapPin, User, Video, X, ChevronDown, Star, Link as LinkIcon, Calendar, Mail, Phone } from 'lucide-react';
// import './AuditionDashbord.css';

// const MAIN_CITIES = [
//   'Mumbai', 'Pune', 'Delhi', 'Bangalore',
//   'Nagpur', 'Nashik', 'Ahilyanagar', 'Sambhajinagar', 'Thane'
// ];

// export default function AuditionDashboard() {
//   const [candidates, setCandidates] = useState([]);
//   const [visibleCount, setVisibleCount] = useState(20);
//   const [selectedCandidate, setSelectedCandidate] = useState(null);

//   const [filters, setFilters] = useState({
//     categories: [],
//     genders: [],
//     productionTypes: [],
//     cities: [],
//     ageMin: 0,
//     ageMax: 100,
//   });

//   useEffect(() => {
//     const fetchCandidates = async () => {
//       try {
//         const API_URL = "https://fs1w4qkflb.execute-api.ap-south-1.amazonaws.com/proud/accessaudtions";
//         const S3_BASE_URL = "https://auditionsww.s3.ap-south-1.amazonaws.com/";

//         const response = await fetch(API_URL);
//         const data = await response.json();

//         const formattedData = data.map(item => ({
//           id: item.auditionId,
//           fullName: item.fullName,
//           age: Number(item.age),
//           dob: item.dob || '',
//           gender: item.gender || 'Other',
//           contactNo: item.contactNo,
//           email: item.email,
//           city: item.city,
//           category: item.category,
//           productionType: item.productionType,
//           title: item.title,
//           experience: item.experience,
//           pastExperience: item.pastExperience,
//           pastProjects: item.pastProjects,
//           roleDescription: item.roleDescription,
//           youtubeLink: item.youtubeLink,
//           socialMedia: item.socialMedia || [],
//           images: item.imageUrls ? item.imageUrls.map(key => S3_BASE_URL + key) : [],
//         }));

//         setCandidates(formattedData);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchCandidates();
//   }, []);

//   const getDisplayCity = (city) => {
//     if (!city) return 'Other';
//     const normalized = city.trim();
//     return MAIN_CITIES.includes(normalized) ? normalized : 'Other';
//   };

//   const filteredCandidates = useMemo(() => {
//     return candidates.filter(candidate => {
//       if (filters.categories.length > 0 && !filters.categories.includes(candidate.category)) return false;
//       if (filters.genders.length > 0 && !filters.genders.includes(candidate.gender)) return false;
//       if (filters.productionTypes.length > 0 && !filters.productionTypes.includes(candidate.productionType)) return false;
//       if (filters.cities.length > 0 && !filters.cities.includes(getDisplayCity(candidate.city))) return false;
//       if (candidate.age < filters.ageMin || candidate.age > filters.ageMax) return false;
//       return true;
//     });
//   }, [candidates, filters]);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (
//         window.innerHeight + document.documentElement.scrollTop >=
//         document.documentElement.offsetHeight - 100
//       ) {
//         setVisibleCount(prev => Math.min(prev + 20, filteredCandidates.length));
//       }
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [filteredCandidates.length]);

//   const toggleFilter = (type, value) => {
//     setFilters(prev => {
//       const list = prev[type];
//       const newList = list.includes(value)
//         ? list.filter(item => item !== value)
//         : [...list, value];
//       return { ...prev, [type]: newList };
//     });
//   };

//   const CheckboxGroup = ({ title, options, type, currentSelected, countAccessor }) => (
//     <div className="filter-group">
//       <h4>{title}</h4>
//       {options.map(opt => {
//         const count = candidates.filter(c => countAccessor(c) === opt).length;
//         return (
//           <label key={opt} className="checkbox-label">
//             <input
//               type="checkbox"
//               checked={currentSelected.includes(opt)}
//               onChange={() => toggleFilter(type, opt)}
//             />
//             <span>{opt}</span>
//             <span className="count">({count})</span>
//           </label>
//         );
//       })}
//     </div>
//   );

//   return (
//     <div className="dashboard-container">
//       <header className="dashboard-header">
//         <div className="header-content">
//           <h1>Audition Talent Pool</h1>
//           <p>{filteredCandidates.length} profiles found matching your criteria</p>
//         </div>
//       </header>

//       <div className="layout-grid">
//         <aside className="sidebar">
//           <div className="filter-card">
//             <div className="filter-header">
//               <h3>Filter by:</h3>
//             </div>

//             <CheckboxGroup
//               title="Category"
//               options={['Actor', 'Model', 'Dancer', 'Singer', 'Voice Artist']}
//               type="categories"
//               currentSelected={filters.categories}
//               countAccessor={(c) => c.category}
//             />

//             <CheckboxGroup
//               title="Gender"
//               options={['Male', 'Female', 'Other']}
//               type="genders"
//               currentSelected={filters.genders}
//               countAccessor={(c) => c.gender}
//             />

//             <CheckboxGroup
//               title="Current City"
//               options={[...MAIN_CITIES, 'Other']}
//               type="cities"
//               currentSelected={filters.cities}
//               countAccessor={(c) => getDisplayCity(c.city)}
//             />

//             <CheckboxGroup
//               title="Production Type"
//               options={['Film', 'TV Commercial (Ad)', 'Web Series', 'Theatre', 'Short Film', 'Other']}
//               type="productionTypes"
//               currentSelected={filters.productionTypes}
//               countAccessor={(c) => c.productionType}
//             />

//             <div className="filter-group">
//               <h4>Age Range</h4>
//               <div className="range-inputs">
//                 <input
//                   type="number"
//                   value={filters.ageMin}
//                   onChange={(e) => setFilters(prev => ({ ...prev, ageMin: Number(e.target.value) }))}
//                   placeholder="Min"
//                 />
//                 <span>-</span>
//                 <input
//                   type="number"
//                   value={filters.ageMax}
//                   onChange={(e) => setFilters(prev => ({ ...prev, ageMax: Number(e.target.value) }))}
//                   placeholder="Max"
//                 />
//               </div>
//             </div>
//           </div>
//         </aside>

//         <main className="results-area">
//           {filteredCandidates.length === 0 ? (
//             <div className="no-results">
//               <h3>No candidates found.</h3>
//               <p>Try adjusting your filters.</p>
//             </div>
//           ) : (
//             filteredCandidates.slice(0, visibleCount).map(candidate => (
//               <div key={candidate.id} className="candidate-card" onClick={() => setSelectedCandidate(candidate)}>
//                 <div className="card-image-wrapper">
//                   <img
//                     src={candidate.images[0] || "https://via.placeholder.com/200?text=No+Image"}
//                     alt={candidate.fullName}
//                   />
//                 </div>

//                 <div className="card-info">
//                   <div className="card-header">
//                     <div>
//                       <h2>{candidate.fullName}</h2>
//                       <div className="sub-header">
//                         <span className={`badge ${candidate.category.toLowerCase().split(' ')[0]}`}>{candidate.category}</span>
//                         <span className="gender-text">• {candidate.gender}</span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="card-meta">
//                     <span className="meta-item"><User size={16} /> {candidate.age} yrs</span>
//                     <span className="meta-item"><MapPin size={16} /> {candidate.city}</span>
//                     <span className="meta-item"><Star size={16} /> {candidate.experience || 'N/A'}</span>
//                   </div>

//                   <p className="card-desc">
//                     {candidate.roleDescription?.length > 100
//                       ? candidate.roleDescription.substring(0, 100) + "..."
//                       : candidate.roleDescription}
//                   </p>
//                 </div>

//                 <div className="card-actions">
//                   <div className="score-box"><span>New</span></div>
//                   <div className="price-dummy">
//                     <small>Interested in</small>
//                     <span>{candidate.productionType}</span>
//                   </div>
//                   <button className="view-btn">
//                     Details <ChevronDown size={16} />
//                   </button>
//                 </div>
//               </div>
//             ))
//           )}

//           {visibleCount < filteredCandidates.length && (
//             <div className="loading-indicator">Loading more profiles...</div>
//           )}
//         </main>
//       </div>

//       {/* --- MODAL --- */}
//       {selectedCandidate && (
//         <div className="modal-overlay" onClick={() => setSelectedCandidate(null)}>
//           <div className="modal-content" onClick={e => e.stopPropagation()}>
//             <button className="close-btn" onClick={() => setSelectedCandidate(null)}>
//               <X size={24} />
//             </button>

//             <div className="modal-header">
//               <h2>{selectedCandidate.fullName}</h2>
//               <p>{selectedCandidate.category} • {selectedCandidate.gender} • {selectedCandidate.city}</p>
//             </div>

//             <div className="modal-body">
//               <div className="modal-gallery">
//                 {selectedCandidate.images.map((img, idx) => (
//                   <img key={idx} src={img} alt={`Gallery ${idx}`} />
//                 ))}
//               </div>

//               <div className="detail-grid">
//                 <div className="detail-row"><strong><Calendar size={16}/> DOB:</strong> {selectedCandidate.dob || 'N/A'}</div>
//                 <div className="detail-row"><strong><User size={16}/> Age:</strong> {selectedCandidate.age}</div>
//                 <div className="detail-row"><strong><Phone size={16}/> Contact:</strong> {selectedCandidate.contactNo}</div>
//                 <div className="detail-row"><strong><Mail size={16}/> Email:</strong> {selectedCandidate.email}</div>
//                 <div className="detail-row"><strong><Star size={16}/> Experience:</strong> {selectedCandidate.experience || 'N/A'}</div>
//                 <div className="detail-row"><strong>Production Type:</strong> {selectedCandidate.productionType}</div>
//                 <div className="detail-row"><strong>Project Title:</strong> {selectedCandidate.title || 'N/A'}</div>
//               </div>

//               <div className="detail-block">
//                 <strong>Role Description:</strong>
//                 <p>{selectedCandidate.roleDescription}</p>
//               </div>

//               {selectedCandidate.pastProjects && (
//                 <div className="detail-block">
//                   <strong>Past Projects:</strong>
//                   <p>{selectedCandidate.pastProjects}</p>
//                 </div>
//               )}

//               {selectedCandidate.pastExperience && (
//                 <div className="detail-block">
//                   <strong>Past Experience:</strong>
//                   <p>{selectedCandidate.pastExperience}</p>
//                 </div>
//               )}

//               {selectedCandidate.socialMedia.length > 0 && (
//                 <div className="detail-block">
//                   <strong>Social Media Links:</strong>
//                   <ul>
//                     {selectedCandidate.socialMedia.map((link, i) => (
//                       <li key={i}>
//                         <LinkIcon size={14} style={{ marginRight: '6px' }} />
//                         <strong>{link.platform}:</strong>{' '}
//                         <a href={link.handle.startsWith('http') ? link.handle : `https://${link.handle}`} target="_blank" rel="noreferrer">
//                           {link.handle}
//                         </a>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               )}

//               {selectedCandidate.youtubeLink && (
//                 <a href={selectedCandidate.youtubeLink} target="_blank" rel="noreferrer" className="youtube-btn">
//                   <Video size={18} /> Watch Audition Tape
//                 </a>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


//3rd update
// import React, { useState, useEffect, useMemo } from 'react';
// import { MapPin, User, Video, Filter, X, ChevronDown, Star, Search, ArrowLeft, ArrowRight, Rss, Layers } from 'lucide-react';
// import './AuditionDashbord.css';


// // List of cities to show explicitly. All others go to "Other"
// const MAIN_CITIES = [
//   'Mumbai', 'Pune', 'Delhi', 'Bangalore', 
//   'Nagpur', 'Nashik', 'Ahilyanagar', 'Sambhajinagar', 'Thane'
// ];

// // List of main production types. All others go to "Other"
// const MAIN_PRODUCTION_TYPES = [
//     'Film', 'TV Commercial', 'Web Series', 'Theatre', 'Short Film'
// ];


// // --- Main Component ---
// export default function AuditionDashboard() {
//   // --- 1. STATE MANAGEMENT ---
//   const [candidates, setCandidates] = useState([]); 
//   const [visibleCount, setVisibleCount] = useState(20); 
//   const [selectedCandidate, setSelectedCandidate] = useState(null); 
//   const [modalImageIndex, setModalImageIndex] = useState(0);

//   // Filter State
//   const [filters, setFilters] = useState({
//     categories: [],
//     genders: [], 
//     productionTypes: [],
//     cities: [],
//     ageMin: 0,
//     ageMax: 60
//   });

//   // --- 2. INITIAL LOAD (Updated to map all new fields) ---
//   useEffect(() => {
//     const fetchCandidates = async () => {
//       try {
//         const API_URL = "https://fs1w4qkflb.execute-api.ap-south-1.amazonaws.com/proud/accessaudtions";
//         const S3_BASE_URL = "https://auditionsww.s3.ap-south-1.amazonaws.com/";

//         const response = await fetch(API_URL);
//         const data = await response.json();

//         const formattedData = data.map(item => ({
//           id: item.auditionId,
//           fullName: item.fullName,
//           age: Number(item.age), // Calculated Age
//           gender: item.gender || 'Not Specified',
//           category: item.category,
//           productionType: item.productionType,
//           city: item.city,
//           experience: item.experience,
//           roleDescription: item.roleDescription,
//           contactNo: item.contactNo,
//           email: item.email,
//           youtubeLink: item.youtubeLink,
          
//           // NEW/UPDATED FIELDS FROM FORM
//           title: item.title, 
//           pastExperience: item.pastExperience, 
//           pastProjects: item.pastProjects, 
//           socialMedia: item.socialMedia || [], // Array of {platform, handle}
          
//           // FIX: Use 'images' key from the API response
//           images: item.images 
//             ? item.images.map(key => S3_BASE_URL + key)
//             : []
//         }));

//         setCandidates(formattedData);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchCandidates();
//   }, []);

//   // --- 3. FILTERING LOGIC & HELPERS ---
//   const getDisplayCity = (city) => {
//     if (!city || typeof city !== 'string') return 'Other';
//     const normalized = city.trim();
//     return MAIN_CITIES.includes(normalized) ? normalized : 'Other';
//   };

//   const getDisplayProductionType = (type) => {
//     if (!type || typeof type !== 'string') return 'Other';
//     const normalized = type.trim();
//     return MAIN_PRODUCTION_TYPES.includes(normalized) ? normalized : 'Other';
//   };


//   const filteredCandidates = useMemo(() => {
//     return candidates.filter(candidate => {
//       // 1. Age Filter
//       if (candidate.age < filters.ageMin || candidate.age > filters.ageMax) return false;

//       // 2. Gender Filter
//       if (filters.genders.length > 0 && !filters.genders.includes(candidate.gender)) return false;

//       // 3. Category Filter
//       if (filters.categories.length > 0 && !filters.categories.includes(candidate.category)) return false;
      
//       // 4. Production Type Filter (With "Other" Logic)
//       if (filters.productionTypes.length > 0) {
//         const group = getDisplayProductionType(candidate.productionType);
//         if (!filters.productionTypes.includes(group)) return false;
//       }
      
//       // 5. City Filter (With "Other" Logic)
//       if (filters.cities.length > 0) {
//         const group = getDisplayCity(candidate.city);
//         if (!filters.cities.includes(group)) return false;
//       }
      
//       return true;
//     });
//   }, [candidates, filters]);

//   // --- 4. LAZY LOADING ---
//   const handleScroll = () => {
//     if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
//       setVisibleCount(prev => Math.min(prev + 20, filteredCandidates.length));
//     }
//   };

//   useEffect(() => {
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [filteredCandidates]);

//   // --- 5. MODAL/FILTER HANDLERS ---
//   const toggleFilter = (type, value) => {
//     setFilters(prev => {
//       const list = prev[type];
//       const newList = list.includes(value) 
//         ? list.filter(item => item !== value)
//         : [...list, value];
//       setVisibleCount(20); 
//       return { ...prev, [type]: newList };
//     });
//   };

//   const openCandidateModal = (candidate, initialImageIndex = 0) => {
//     setSelectedCandidate(candidate);
//     setModalImageIndex(initialImageIndex);
//   };

//   const closeCandidateModal = () => {
//     setSelectedCandidate(null);
//   };

//   const navigateModalImages = (direction) => {
//     const imagesCount = selectedCandidate.images.length;
//     setModalImageIndex(prevIndex => {
//         let newIndex = prevIndex + direction;
//         if (newIndex < 0) newIndex = imagesCount - 1;
//         if (newIndex >= imagesCount) newIndex = 0;
//         return newIndex;
//     });
//   };


//   // --- 6. REUSABLE CHECKBOX COMPONENT ---
//   const CheckboxGroup = ({ title, options, type, currentSelected, countAccessor }) => (
//     <div className="filter-group">
//       <h4>{title}</h4>
//       {options.map(opt => {
//         const count = candidates.filter(c => countAccessor(c) === opt).length;
        
//         return (
//           <label key={opt} className="checkbox-label">
//             <input 
//               type="checkbox" 
//               checked={currentSelected.includes(opt)}
//               onChange={() => toggleFilter(type, opt)}
//             />
//             <span>{opt}</span>
//             <span className="count">({count})</span>
//           </label>
//         );
//       })}
//     </div>
//   );

//   // --- 7. RENDER ---
//   return (
//     <div className="dashboard-container">
//       {/* HEADER */}
//       <header className="dashboard-header">
//         <div className="header-content">
//           <h1>Audition Talent Pool</h1>
//           <p>{filteredCandidates.length} profiles found matching your criteria</p>
//         </div>
//       </header>

//       <div className="layout-grid">
        
//         {/* LEFT SIDEBAR: FILTERS */}
//         <aside className="sidebar">
//           <div className="filter-card">
//             <div className="filter-header">
//               <h3><Filter size={18} /> Filter by:</h3>
//             </div>
            
//             {/* Age Range (MOVED TO TOP) */}
//             <div className="filter-group">
//               <h4>Age Range</h4>
//               <div className="range-inputs">
//                 <input 
//                   type="number" 
//                   value={filters.ageMin} 
//                   onChange={(e) => setFilters(prev => ({...prev, ageMin: Number(e.target.value)}))}
//                   placeholder="Min"
//                   min="1"
//                   max="100"
//                 />
//                 <span>-</span>
//                 <input 
//                   type="number" 
//                   value={filters.ageMax} 
//                   onChange={(e) => setFilters(prev => ({...prev, ageMax: Number(e.target.value)}))}
//                   placeholder="Max"
//                   min="1"
//                   max="100"
//                 />
//               </div>
//             </div>

//             {/* Gender (NEW) */}
//             <CheckboxGroup 
//               title="Gender" 
//               options={['Male', 'Female', 'Other', 'Not Specified']} 
//               type="genders"
//               currentSelected={filters.genders}
//               countAccessor={(c) => c.gender}
//             />
            
//             {/* Category */}
//             <CheckboxGroup 
//               title="Category" 
//               options={['Actor', 'Model', 'Dancer', 'Singer', 'Voice Artist','Other']} 
//               type="categories"
//               currentSelected={filters.categories}
//               countAccessor={(c) => c.category}
//             />

//             {/* City (UPDATED CITIES + 'Other') */}
//             <CheckboxGroup 
//               title="Current City" 
//               options={[...MAIN_CITIES, 'Other']} 
//               type="cities"
//               currentSelected={filters.cities}
//               countAccessor={(c) => getDisplayCity(c.city)}
//             />

//             {/* Interested In (UPDATED TYPES + 'Other') */}
//             <CheckboxGroup 
//               title="Interested In" 
//               options={[...MAIN_PRODUCTION_TYPES, 'Other']} 
//               type="productionTypes"
//               currentSelected={filters.productionTypes}
//               countAccessor={(c) => getDisplayProductionType(c.productionType)}
//             />

//           </div>
//         </aside>

//         {/* MAIN CONTENT: CANDIDATE CARDS */}
//         <main className="results-area">
//           {filteredCandidates.length === 0 ? (
//             <div className="no-results">
//               <h3>No candidates found.</h3>
//               <p>Try adjusting your filters.</p>
//             </div>
//           ) : (
//             filteredCandidates.slice(0, visibleCount).map(candidate => (
//               <div key={candidate.id} className="candidate-card" onClick={() => openCandidateModal(candidate)}>
                
//                 {/* Left: Image */}
//                 <div className="card-image-wrapper">
//                   <img 
//                     src={candidate.images[0] || "https://via.placeholder.com/200?text=No+Image"} 
//                     alt={candidate.fullName} 
//                   />
//                 </div>

//                 {/* Middle: Info */}
//                 <div className="card-info">
//                   <div className="card-header">
//                     <h2>{candidate.fullName}</h2>
//                     <span className={`badge ${candidate.category.toLowerCase().replace(/\s/g, '-')}`}>{candidate.category}</span>
//                   </div>
                  
//                   <div className="card-meta">
//                     <span className="meta-item"><User size={16} /> {candidate.age} yrs ({candidate.gender})</span>
//                     <span className="meta-item"><MapPin size={16} /> {candidate.city}</span>
//                     <span className="meta-item"><Star size={16} /> Exp: {candidate.experience}</span>
//                   </div>

//                   <p className="card-desc">
//                     {candidate.roleDescription 
//                       ? candidate.roleDescription.substring(0, 100) + (candidate.roleDescription.length > 100 ? "..." : "") 
//                       : "No description provided."}
//                   </p>
//                 </div>

//                 {/* Right: Actions */}
//                 <div className="card-actions">
//                   <div className="price-dummy">
//                     <small>Project</small>
//                     <span>{candidate.title || candidate.productionType}</span>
//                   </div>
//                   <button className="view-btn">
//                     View Profile <ChevronDown size={16} />
//                   </button>
//                 </div>
//               </div>
//             ))
//           )}
          
//           {visibleCount < filteredCandidates.length && (
//             <div className="loading-indicator">Loading more profiles...</div>
//           )}
//         </main>
//       </div>

//       {/* MODAL POPUP (Updated) */}
//       {selectedCandidate && (
//         <div className="modal-overlay" onClick={closeCandidateModal}>
//           <div className="modal-content" onClick={e => e.stopPropagation()}>
//             <button className="close-btn" onClick={closeCandidateModal}><X size={24}/></button>
            
//             <div className="modal-header">
//               <h2>{selectedCandidate.fullName}</h2>
//               <p>{selectedCandidate.category} • {selectedCandidate.city}</p>
//             </div>

//             <div className="modal-body">
              
//               {/* Image Slider/Gallery */}
//               {selectedCandidate.images.length > 0 ? (
//                 <div className="image-slider-container">
//                     <img 
//                         src={selectedCandidate.images[modalImageIndex]} 
//                         alt={`${selectedCandidate.fullName} ${modalImageIndex + 1}`} 
//                         className="modal-main-image"
//                     />
//                     {selectedCandidate.images.length > 1 && (
//                         <>
//                             <button className="slider-btn prev-btn" onClick={() => navigateModalImages(-1)}>
//                                 <ArrowLeft size={24} />
//                             </button>
//                             <button className="slider-btn next-btn" onClick={() => navigateModalImages(1)}>
//                                 <ArrowRight size={24} />
//                             </button>
//                             <div className="image-thumbnails">
//                                 {selectedCandidate.images.map((img, idx) => (
//                                     <img 
//                                         key={idx} 
//                                         src={img} 
//                                         alt={`Thumbnail ${idx}`} 
//                                         className={idx === modalImageIndex ? 'active' : ''}
//                                         onClick={() => setModalImageIndex(idx)}
//                                     />
//                                 ))}
//                             </div>
//                         </>
//                     )}
//                 </div>
//               ) : (
//                 <div className="no-image-placeholder">No Images Available</div>
//               )}

//               <div className="modal-details">
//                 {/* BASIC INFO GRID */}
//                 <div className="detail-grid">
//                     <div className="detail-row"><strong>Gender:</strong> {selectedCandidate.gender}</div>
//                     <div className="detail-row"><strong>Age:</strong> {selectedCandidate.age}</div>
//                     <div className="detail-row"><strong>Experience:</strong> {selectedCandidate.experience}</div>
//                     <div className="detail-row"><strong>Contact:</strong> {selectedCandidate.contactNo}</div>
//                     <div className="detail-row"><strong>Email:</strong> {selectedCandidate.email}</div>
//                     <div className="detail-row"><strong>Category:</strong> {selectedCandidate.category}</div>
//                 </div>
                
//                 {/* PROJECT DETAILS */}
//                 <div className="detail-block">
//                     <h4><Layers size={16} style={{marginRight: '5px'}}/> Project Details</h4>
//                     <div className="detail-row"><strong>Title/Project:</strong> {selectedCandidate.title || 'N/A'}</div>
//                     <div className="detail-row"><strong>Interested In:</strong> {selectedCandidate.productionType}</div>
//                 </div>

//                 {/* ROLE DESCRIPTION */}
//                 <div className="detail-block full">
//                   <h4>Role Description:</h4>
//                   <p>{selectedCandidate.roleDescription}</p>
//                 </div>
                
//                 {/* PAST EXPERIENCE */}
//                 <div className="detail-block full">
//                     <h4>Past Projects</h4>
//                     <p>{selectedCandidate.pastProjects || 'No past projects listed.'}</p>
//                 </div>
                
//                 {/* TRAINING/ADDITIONAL EXPERIENCE */}
//                 <div className="detail-block full">
//                     <h4>Detailed Experience / Training</h4>
//                     <p>{selectedCandidate.pastExperience || 'No detailed experience/training provided.'}</p>
//                 </div>

//                 {/* SOCIAL MEDIA LINKS */}
//                 {selectedCandidate.socialMedia && selectedCandidate.socialMedia.length > 0 && (
//                     <div className="detail-block full">
//                         <h4><Rss size={16} style={{marginRight: '5px'}}/> Social Media / Links</h4>
//                         <ul className="social-links-list">
//                             {selectedCandidate.socialMedia.map((social, index) => (
//                                 <li key={index} className="social-link-item">
//                                     <strong>{social.platform}:</strong> 
//                                     <a href={social.handle} target="_blank" rel="noreferrer">{social.handle}</a>
//                                 </li>
//                             ))}
//                         </ul>
//                     </div>
//                 )}
                
//                 {/* YOUTUBE LINK */}
//                 {selectedCandidate.youtubeLink && (
//                   <a href={selectedCandidate.youtubeLink} target="_blank" rel="noreferrer" className="youtube-btn">
//                     <Video size={18} /> Watch Audition Tape
//                   </a>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// import React, { useState, useEffect, useMemo } from 'react';
// import { MapPin, User, Video, Filter, X, ChevronDown, Star, Search, ArrowLeft, ArrowRight, Rss, Layers } from 'lucide-react';
// import './AuditionDashbord.css';


// // List of cities to show explicitly. All others go to "Other"
// const MAIN_CITIES = [
//   'Mumbai', 'Pune', 'Delhi', 'Bangalore', 
//   'Nagpur', 'Nashik', 'Ahilyanagar', 'Sambhajinagar', 'Thane'
// ];

// // List of main production types/categories for the Filter Group
// const MAIN_PRODUCTION_TYPES = [
//     'Film', 
//     'TV Commercial', 
//     'Web Series', 
//     'Theatre', 
//     'Short Film'
// ];


// // --- Main Component ---
// export default function AuditionDashboard() {
//   // --- 1. STATE MANAGEMENT ---
//   const [candidates, setCandidates] = useState([]); 
//   const [visibleCount, setVisibleCount] = useState(20); 
//   const [selectedCandidate, setSelectedCandidate] = useState(null); 
//   const [modalImageIndex, setModalImageIndex] = useState(0);

//   // Filter State
//   const [filters, setFilters] = useState({
//     categories: [],
//     genders: [], 
//     productionTypes: [], // This maps to "Interested In" / Production Type
//     cities: [],
//     ageMin: 0,
//     ageMax: 60
//   });

//   // --- 2. INITIAL LOAD ---
//   useEffect(() => {
//     const fetchCandidates = async () => {
//       try {
//         const API_URL = "https://fs1w4qkflb.execute-api.ap-south-1.amazonaws.com/proud/accessaudtions";
//         const S3_BASE_URL = "https://auditionsww.s3.ap-south-1.amazonaws.com/";

//         const response = await fetch(API_URL);
//         const data = await response.json();

//         const formattedData = data.map(item => ({
//           id: item.auditionId,
//           fullName: item.fullName,
//           age: Number(item.age),
//           gender: item.gender || 'Not Specified',
//           category: item.category,
//           productionType: item.productionType, // e.g., "TV Commercial (Ad)"
//           city: item.city,
//           experience: item.experience,
//           roleDescription: item.roleDescription,
//           contactNo: item.contactNo,
//           email: item.email,
//           youtubeLink: item.youtubeLink,
          
//           // Additional fields based on your JSON
//           title: item.title, 
//           pastExperience: item.pastExperience, 
//           pastProjects: item.pastProjects, 
//           socialMedia: item.socialMedia || [], 
          
//           images: item.images 
//             ? item.images.map(key => S3_BASE_URL + key)
//             : []
//         }));

//         setCandidates(formattedData);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchCandidates();
//   }, []);

//   // --- 3. FILTERING LOGIC & HELPERS ---
  
//   const getDisplayCity = (city) => {
//     if (!city || typeof city !== 'string') return 'Other';
//     const normalized = city.trim();
//     return MAIN_CITIES.includes(normalized) ? normalized : 'Other';
//   };

//   /**
//    * UPDATED LOGIC: Smart matching for Production Type
//    * This handles cases where API returns "TV Commercial (Ad)" 
//    * but we want to filter it under "TV Commercial".
//    */
//   const getDisplayProductionType = (type) => {
//     if (!type || typeof type !== 'string') return 'Other';
//     const lowerType = type.toLowerCase();

//     if (lowerType.includes('commercial') || lowerType.includes('ad')) return 'TV Commercial';
//     if (lowerType.includes('web series')) return 'Web Series';
//     // Check for "Short Film" before "Film" to avoid misclassification
//     if (lowerType.includes('short film') || lowerType.includes('short')) return 'Short Film';
//     if (lowerType.includes('film')) return 'Film';
//     if (lowerType.includes('theatre')) return 'Theatre';

//     return 'Other';
//   };


//   const filteredCandidates = useMemo(() => {
//     return candidates.filter(candidate => {
//       // 1. Age Filter
//       if (candidate.age < filters.ageMin || candidate.age > filters.ageMax) return false;

//       // 2. Gender Filter
//       if (filters.genders.length > 0 && !filters.genders.includes(candidate.gender)) return false;

//       // 3. Category Filter
//       if (filters.categories.length > 0 && !filters.categories.includes(candidate.category)) return false;
      
//       // 4. Production Type Filter (UPDATED)
//       if (filters.productionTypes.length > 0) {
//         // We normalize the candidate's specific string (e.g., "TV Commercial (Ad)")
//         // to the bucket name (e.g., "TV Commercial") to see if it matches the filter.
//         const group = getDisplayProductionType(candidate.productionType);
//         if (!filters.productionTypes.includes(group)) return false;
//       }
      
//       // 5. City Filter
//       if (filters.cities.length > 0) {
//         const group = getDisplayCity(candidate.city);
//         if (!filters.cities.includes(group)) return false;
//       }
      
//       return true;
//     });
//   }, [candidates, filters]);

//   // --- 4. LAZY LOADING ---
//   const handleScroll = () => {
//     if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
//       setVisibleCount(prev => Math.min(prev + 20, filteredCandidates.length));
//     }
//   };

//   useEffect(() => {
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [filteredCandidates]);

//   // --- 5. MODAL/FILTER HANDLERS ---
//   const toggleFilter = (type, value) => {
//     setFilters(prev => {
//       const list = prev[type];
//       const newList = list.includes(value) 
//         ? list.filter(item => item !== value)
//         : [...list, value];
//       setVisibleCount(20); 
//       return { ...prev, [type]: newList };
//     });
//   };

//   const openCandidateModal = (candidate, initialImageIndex = 0) => {
//     setSelectedCandidate(candidate);
//     setModalImageIndex(initialImageIndex);
//   };

//   const closeCandidateModal = () => {
//     setSelectedCandidate(null);
//   };

//   const navigateModalImages = (direction) => {
//     const imagesCount = selectedCandidate.images.length;
//     setModalImageIndex(prevIndex => {
//         let newIndex = prevIndex + direction;
//         if (newIndex < 0) newIndex = imagesCount - 1;
//         if (newIndex >= imagesCount) newIndex = 0;
//         return newIndex;
//     });
//   };


//   // --- 6. REUSABLE CHECKBOX COMPONENT ---
//   const CheckboxGroup = ({ title, options, type, currentSelected, countAccessor }) => (
//     <div className="filter-group">
//       <h4>{title}</h4>
//       {options.map(opt => {
//         // Use the accessor to count how many candidates fall into this bucket
//         const count = candidates.filter(c => countAccessor(c) === opt).length;
        
//         return (
//           <label key={opt} className="checkbox-label">
//             <input 
//               type="checkbox" 
//               checked={currentSelected.includes(opt)}
//               onChange={() => toggleFilter(type, opt)}
//             />
//             <span>{opt}</span>
//             <span className="count">({count})</span>
//           </label>
//         );
//       })}
//     </div>
//   );

//   // --- 7. RENDER ---
//   return (
//     <div className="dashboard-container">
//       {/* HEADER */}
//       <header className="dashboard-header">
//         <div className="header-content">
//           <h1>Audition Talent Pool</h1>
//           <p>{filteredCandidates.length} profiles found matching your criteria</p>
//         </div>
//       </header>

//       <div className="layout-grid">
        
//         {/* LEFT SIDEBAR: FILTERS */}
//         <aside className="sidebar">
//           <div className="filter-card">
//             <div className="filter-header">
//               <h3><Filter size={18} /> Filter by:</h3>
//             </div>
            
//             {/* Age Range */}
//             <div className="filter-group">
//               <h4>Age Range</h4>
//               <div className="range-inputs">
//                 <input 
//                   type="number" 
//                   value={filters.ageMin} 
//                   onChange={(e) => setFilters(prev => ({...prev, ageMin: Number(e.target.value)}))}
//                   placeholder="Min"
//                   min="1"
//                   max="100"
//                 />
//                 <span>-</span>
//                 <input 
//                   type="number" 
//                   value={filters.ageMax} 
//                   onChange={(e) => setFilters(prev => ({...prev, ageMax: Number(e.target.value)}))}
//                   placeholder="Max"
//                   min="1"
//                   max="100"
//                 />
//               </div>
//             </div>

//             {/* Gender */}
//             <CheckboxGroup 
//               title="Gender" 
//               options={['Male', 'Female', 'Other', 'Not Specified']} 
//               type="genders"
//               currentSelected={filters.genders}
//               countAccessor={(c) => c.gender}
//             />
            
//             {/* Category */}
//             <CheckboxGroup 
//               title="Category" 
//               options={['Actor', 'Model', 'Dancer', 'Singer', 'Voice Artist','Other']} 
//               type="categories"
//               currentSelected={filters.categories}
//               countAccessor={(c) => c.category}
//             />

//             {/* City */}
//             <CheckboxGroup 
//               title="Current City" 
//               options={[...MAIN_CITIES, 'Other']} 
//               type="cities"
//               currentSelected={filters.cities}
//               countAccessor={(c) => getDisplayCity(c.city)}
//             />

//             {/* Production Type (Was 'Interested In') */}
//             {/* We map the raw API string to the Bucket Group using getDisplayProductionType */}
//             <CheckboxGroup 
//               title="Production Type" 
//               options={[...MAIN_PRODUCTION_TYPES, 'Other']} 
//               type="productionTypes"
//               currentSelected={filters.productionTypes}
//               countAccessor={(c) => getDisplayProductionType(c.productionType)}
//             />

//           </div>
//         </aside>

//         {/* MAIN CONTENT: CANDIDATE CARDS */}
//         <main className="results-area">
//           {filteredCandidates.length === 0 ? (
//             <div className="no-results">
//               <h3>No candidates found.</h3>
//               <p>Try adjusting your filters.</p>
//             </div>
//           ) : (
//             filteredCandidates.slice(0, visibleCount).map(candidate => (
//               <div key={candidate.id} className="candidate-card" onClick={() => openCandidateModal(candidate)}>
                
//                 {/* Left: Image */}
//                 <div className="card-image-wrapper">
//                   <img 
//                     src={candidate.images[0] || "https://via.placeholder.com/200?text=No+Image"} 
//                     alt={candidate.fullName} 
//                   />
//                 </div>

//                 {/* Middle: Info */}
//                 <div className="card-info">
//                   <div className="card-header">
//                     <h2>{candidate.fullName}</h2>
//                     <span className={`badge ${candidate.category.toLowerCase().replace(/\s/g, '-')}`}>{candidate.category}</span>
//                   </div>
                  
//                   <div className="card-meta">
//                     <span className="meta-item"><User size={16} /> {candidate.age} yrs ({candidate.gender})</span>
//                     <span className="meta-item"><MapPin size={16} /> {candidate.city}</span>
//                     <span className="meta-item"><Star size={16} /> Exp: {candidate.experience}</span>
//                   </div>

//                   <p className="card-desc">
//                     {candidate.roleDescription 
//                       ? candidate.roleDescription.substring(0, 100) + (candidate.roleDescription.length > 100 ? "..." : "") 
//                       : "No description provided."}
//                   </p>
//                 </div>

//                 {/* Right: Actions */}
//                 <div className="card-actions">
//                   <div className="price-dummy">
//                     <small>Type</small>
//                     {/* Display the original API value here for detail accuracy */}
//                     <span>{candidate.productionType || 'N/A'}</span>
//                   </div>
//                   <button className="view-btn">
//                     View Profile <ChevronDown size={16} />
//                   </button>
//                 </div>
//               </div>
//             ))
//           )}
          
//           {visibleCount < filteredCandidates.length && (
//             <div className="loading-indicator">Loading more profiles...</div>
//           )}
//         </main>
//       </div>

//       {/* MODAL POPUP */}
//       {selectedCandidate && (
//         <div className="modal-overlay" onClick={closeCandidateModal}>
//           <div className="modal-content" onClick={e => e.stopPropagation()}>
//             <button className="close-btn" onClick={closeCandidateModal}><X size={24}/></button>
            
//             <div className="modal-header">
//               <h2>{selectedCandidate.fullName}</h2>
//               <p>{selectedCandidate.category} • {selectedCandidate.city}</p>
//             </div>

//             <div className="modal-body">
              
//               {/* Image Slider */}
//               {selectedCandidate.images.length > 0 ? (
//                 <div className="image-slider-container">
//                     <img 
//                         src={selectedCandidate.images[modalImageIndex]} 
//                         alt={`${selectedCandidate.fullName} ${modalImageIndex + 1}`} 
//                         className="modal-main-image"
//                     />
//                     {selectedCandidate.images.length > 1 && (
//                         <>
//                             <button className="slider-btn prev-btn" onClick={() => navigateModalImages(-1)}>
//                                 <ArrowLeft size={24} />
//                             </button>
//                             <button className="slider-btn next-btn" onClick={() => navigateModalImages(1)}>
//                                 <ArrowRight size={24} />
//                             </button>
//                             <div className="image-thumbnails">
//                                 {selectedCandidate.images.map((img, idx) => (
//                                     <img 
//                                         key={idx} 
//                                         src={img} 
//                                         alt={`Thumbnail ${idx}`} 
//                                         className={idx === modalImageIndex ? 'active' : ''}
//                                         onClick={() => setModalImageIndex(idx)}
//                                     />
//                                 ))}
//                             </div>
//                         </>
//                     )}
//                 </div>
//               ) : (
//                 <div className="no-image-placeholder">No Images Available</div>
//               )}

//               <div className="modal-details">
//                 {/* BASIC INFO GRID */}
//                 <div className="detail-grid">
//                     <div className="detail-row"><strong>Gender:</strong> {selectedCandidate.gender}</div>
//                     <div className="detail-row"><strong>Age:</strong> {selectedCandidate.age}</div>
//                     <div className="detail-row"><strong>Experience:</strong> {selectedCandidate.experience}</div>
//                     <div className="detail-row"><strong>Contact:</strong> {selectedCandidate.contactNo}</div>
//                     <div className="detail-row"><strong>Email:</strong> {selectedCandidate.email}</div>
//                     <div className="detail-row"><strong>Category:</strong> {selectedCandidate.category}</div>
//                 </div>
                
//                 {/* PROJECT DETAILS */}
//                 <div className="detail-block">
//                     <h4><Layers size={16} style={{marginRight: '5px'}}/> Project Details</h4>
//                     <div className="detail-row"><strong>Title/Project:</strong> {selectedCandidate.title || 'N/A'}</div>
//                     <div className="detail-row"><strong>Production Type:</strong> {selectedCandidate.productionType}</div>
//                 </div>

//                 {/* ROLE DESCRIPTION */}
//                 <div className="detail-block full">
//                   <h4>Role Description:</h4>
//                   <p>{selectedCandidate.roleDescription}</p>
//                 </div>
                
//                 {/* PAST PROJECTS */}
//                 <div className="detail-block full">
//                     <h4>Past Projects</h4>
//                     <p>{selectedCandidate.pastProjects || 'No past projects listed.'}</p>
//                 </div>
                
//                 {/* DETAILED EXPERIENCE */}
//                 <div className="detail-block full">
//                     <h4>Detailed Experience / Training</h4>
//                     <p>{selectedCandidate.pastExperience || 'No detailed experience/training provided.'}</p>
//                 </div>

//                 {/* SOCIAL MEDIA LINKS */}
//                 {selectedCandidate.socialMedia && selectedCandidate.socialMedia.length > 0 && (
//                     <div className="detail-block full">
//                         <h4><Rss size={16} style={{marginRight: '5px'}}/> Social Media / Links</h4>
//                         <ul className="social-links-list">
//                             {selectedCandidate.socialMedia.map((social, index) => (
//                                 <li key={index} className="social-link-item">
//                                     <strong>{social.platform}:</strong> 
//                                     <a href={social.handle} target="_blank" rel="noreferrer">{social.handle}</a>
//                                 </li>
//                             ))}
//                         </ul>
//                     </div>
//                 )}
                
//                 {/* YOUTUBE LINK */}
//                 {selectedCandidate.youtubeLink && (
//                   <a href={selectedCandidate.youtubeLink} target="_blank" rel="noreferrer" className="youtube-btn">
//                     <Video size={18} /> Watch Audition Tape
//                   </a>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }



//Updated 06/12/2025

// import React, { useState, useEffect, useMemo } from 'react';
// import { MapPin, User, Video, Filter, X, ChevronDown, Star, ArrowLeft, ArrowRight, Rss, Layers, FileText } from 'lucide-react';
// import './AuditionDashbord.css';

// // List of cities to show explicitly. All others go to "Other"
// const MAIN_CITIES = [
//   'Mumbai', 'Pune', 'Delhi', 'Bangalore', 
//   'Nagpur', 'Nashik', 'Ahilyanagar', 'Sambhajinagar', 'Thane'
// ];


// // Updated: Replaced "TV Commercial" with "Advertisement"
// const MAIN_PRODUCTION_TYPES = [
//     'Film', 
//     'Advertisement', 
//     'Web Series', 
//     'Theatre', 
//     'Short Film'
// ];

// // --- Main Component ---
// export default function AuditionDashboard() {
//   // --- 1. STATE MANAGEMENT ---
//   const [candidates, setCandidates] = useState([]); 
//   const [visibleCount, setVisibleCount] = useState(20); 
//   const [selectedCandidate, setSelectedCandidate] = useState(null); 
//   const [modalImageIndex, setModalImageIndex] = useState(0);

//   // Filter State
//   const [filters, setFilters] = useState({
//     categories: [],
//     genders: [], 
//     productionTypes: [], 
//     cities: [],
//     ageMin: 0,
//     ageMax: 60
//   });

//   // --- 2. INITIAL LOAD ---
//   useEffect(() => {
//     const fetchCandidates = async () => {
//       try {
//         const API_URL = "https://fs1w4qkflb.execute-api.ap-south-1.amazonaws.com/proud/accessaudtions";
//         const S3_BASE_URL = "https://auditionsww.s3.ap-south-1.amazonaws.com/";

//         const response = await fetch(API_URL);
//         const data = await response.json();

//         const formattedData = data.map(item => ({
//           id: item.auditionId,
//           fullName: item.fullName,
//           age: Number(item.age),
//           gender: item.gender || 'Not Specified',
//           category: item.category,
//           productionType: item.productionType, 
//           city: item.city,
//           experience: item.experience,
//           roleDescription: item.roleDescription,
//           contactNo: item.contactNo,
//           email: item.email,
//           youtubeLink: item.youtubeLink,
          
//           // Additional fields
//           title: item.title, 
//           pastExperience: item.pastExperience, 
//           pastProjects: item.pastProjects,
          
//           // NEW: Mapped the "Any Other Details" field
//           otherDetails: item.otherDetails || '', 
          
//           socialMedia: item.socialMedia || [], 
//           images: item.images 
//             ? item.images.map(key => S3_BASE_URL + key)
//             : []
//         }));

//         setCandidates(formattedData);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchCandidates();
//   }, []);

//   // --- 3. FILTERING LOGIC & HELPERS ---
  
//   const getDisplayCity = (city) => {
//     if (!city || typeof city !== 'string') return 'Other';
//     const normalized = city.trim();
//     return MAIN_CITIES.includes(normalized) ? normalized : 'Other';
//   };

//   /**
//    * UPDATED LOGIC: Replaced TV Commercial with Advertisement
//    */
//   const getDisplayProductionType = (type) => {
//     if (!type || typeof type !== 'string') return 'Other';
//     const lowerType = type.toLowerCase();

//     // Map keywords to "Advertisement"
//     if (lowerType.includes('commercial') || lowerType.includes('ad')) return 'Advertisement';
    
//     if (lowerType.includes('web series')) return 'Web Series';
//     if (lowerType.includes('short film') || lowerType.includes('short')) return 'Short Film';
//     if (lowerType.includes('film')) return 'Film';
//     if (lowerType.includes('theatre')) return 'Theatre';

//     return 'Other';
//   };

//   const filteredCandidates = useMemo(() => {
//     return candidates.filter(candidate => {
//       // 1. Age Filter
//       if (candidate.age < filters.ageMin || candidate.age > filters.ageMax) return false;

//       // 2. Gender Filter
//       if (filters.genders.length > 0 && !filters.genders.includes(candidate.gender)) return false;

//       // 3. Category Filter
//       if (filters.categories.length > 0 && !filters.categories.includes(candidate.category)) return false;
      
//       // 4. Production Type Filter
//       if (filters.productionTypes.length > 0) {
//         const group = getDisplayProductionType(candidate.productionType);
//         if (!filters.productionTypes.includes(group)) return false;
//       }
      
//       // 5. City Filter
//       if (filters.cities.length > 0) {
//         const group = getDisplayCity(candidate.city);
//         if (!filters.cities.includes(group)) return false;
//       }
      
//       return true;
//     });
//   }, [candidates, filters]);

//   // --- 4. LAZY LOADING ---
//   const handleScroll = () => {
//     if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
//       setVisibleCount(prev => Math.min(prev + 20, filteredCandidates.length));
//     }
//   };

//   useEffect(() => {
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [filteredCandidates]);

//   // --- 5. MODAL/FILTER HANDLERS ---
//   const toggleFilter = (type, value) => {
//     setFilters(prev => {
//       const list = prev[type];
//       const newList = list.includes(value) 
//         ? list.filter(item => item !== value)
//         : [...list, value];
//       setVisibleCount(20); 
//       return { ...prev, [type]: newList };
//     });
//   };

//   const openCandidateModal = (candidate, initialImageIndex = 0) => {
//     setSelectedCandidate(candidate);
//     setModalImageIndex(initialImageIndex);
//   };

//   const closeCandidateModal = () => {
//     setSelectedCandidate(null);
//   };

//   const navigateModalImages = (direction) => {
//     const imagesCount = selectedCandidate.images.length;
//     setModalImageIndex(prevIndex => {
//         let newIndex = prevIndex + direction;
//         if (newIndex < 0) newIndex = imagesCount - 1;
//         if (newIndex >= imagesCount) newIndex = 0;
//         return newIndex;
//     });
//   };

//   // --- 6. REUSABLE CHECKBOX COMPONENT ---
//   const CheckboxGroup = ({ title, options, type, currentSelected, countAccessor }) => (
//     <div className="filter-group">
//       <h4>{title}</h4>
//       {options.map(opt => {
//         const count = candidates.filter(c => countAccessor(c) === opt).length;
        
//         return (
//           <label key={opt} className="checkbox-label">
//             <input 
//               type="checkbox" 
//               checked={currentSelected.includes(opt)}
//               onChange={() => toggleFilter(type, opt)}
//             />
//             <span>{opt}</span>
//             <span className="count">({count})</span>
//           </label>
//         );
//       })}
//     </div>
//   );

//   // --- 7. RENDER ---
//   return (
//     <div className="dashboard-container">
//       {/* HEADER */}
//       <header className="dashboard-header">
//         <div className="header-content">
//           <h1>Audition Talent Pool</h1>
//           <p>{filteredCandidates.length} profiles found matching your criteria</p>
//         </div>
//       </header>

//       <div className="layout-grid">
        
//         {/* LEFT SIDEBAR: FILTERS */}
//         <aside className="sidebar">
//           <div className="filter-card">
//             <div className="filter-header">
//               <h3><Filter size={18} /> Filter by:</h3>
//             </div>
            
//             {/* Age Range */}
//             <div className="filter-group">
//               <h4>Age Range</h4>
//               <div className="range-inputs">
//                 <input 
//                   type="number" 
//                   value={filters.ageMin} 
//                   onChange={(e) => setFilters(prev => ({...prev, ageMin: Number(e.target.value)}))}
//                   placeholder="Min"
//                   min="1"
//                   max="100"
//                 />
//                 <span>-</span>
//                 <input 
//                   type="number" 
//                   value={filters.ageMax} 
//                   onChange={(e) => setFilters(prev => ({...prev, ageMax: Number(e.target.value)}))}
//                   placeholder="Max"
//                   min="1"
//                   max="100"
//                 />
//               </div>
//             </div>

//             {/* Gender */}
//             <CheckboxGroup 
//               title="Gender" 
//               options={['Male', 'Female', 'Other', 'Not Specified']} 
//               type="genders"
//               currentSelected={filters.genders}
//               countAccessor={(c) => c.gender}
//             />
            
//             {/* Category */}
//             <CheckboxGroup 
//               title="Category" 
//               options={['Actor', 'Model', 'Dancer', 'Singer', 'Voice Artist','Other']} 
//               type="categories"
//               currentSelected={filters.categories}
//               countAccessor={(c) => c.category}
//             />

//             {/* City */}
//             <CheckboxGroup 
//               title="Current City" 
//               options={[...MAIN_CITIES, 'Other']} 
//               type="cities"
//               currentSelected={filters.cities}
//               countAccessor={(c) => getDisplayCity(c.city)}
//             />

//             {/* Production Type (Updated to Advertisement) */}
//             <CheckboxGroup 
//               title="Production Type" 
//               options={[...MAIN_PRODUCTION_TYPES, 'Other']} 
//               type="productionTypes"
//               currentSelected={filters.productionTypes}
//               countAccessor={(c) => getDisplayProductionType(c.productionType)}
//             />

//           </div>
//         </aside>

//         {/* MAIN CONTENT: CANDIDATE CARDS */}
//         <main className="results-area">
//           {filteredCandidates.length === 0 ? (
//             <div className="no-results">
//               <h3>No candidates found.</h3>
//               <p>Try adjusting your filters.</p>
//             </div>
//           ) : (
//             filteredCandidates.slice(0, visibleCount).map(candidate => (
//               <div key={candidate.id} className="candidate-card" onClick={() => openCandidateModal(candidate)}>
                
//                 {/* Left: Image */}
//                 <div className="card-image-wrapper">
//                   <img 
//                     src={candidate.images[0] || "https://via.placeholder.com/200?text=No+Image"} 
//                     alt={candidate.fullName} 
//                   />
//                 </div>

//                 {/* Middle: Info */}
//                 <div className="card-info">
//                   <div className="card-header">
//                     <h2>{candidate.fullName}</h2>
//                     <span className={`badge ${candidate.category.toLowerCase().replace(/\s/g, '-')}`}>{candidate.category}</span>
//                   </div>
                  
//                   <div className="card-meta">
//                     <span className="meta-item"><User size={16} /> {candidate.age} yrs ({candidate.gender})</span>
//                     <span className="meta-item"><MapPin size={16} /> {candidate.city}</span>
//                     <span className="meta-item"><Star size={16} /> Exp: {candidate.experience}</span>
//                   </div>

//                   <p className="card-desc">
//                     {candidate.roleDescription 
//                       ? candidate.roleDescription.substring(0, 100) + (candidate.roleDescription.length > 100 ? "..." : "") 
//                       : "No description provided."}
//                   </p>
//                 </div>

//                 {/* Right: Actions */}
//                 <div className="card-actions">
//                   <div className="price-dummy">
//                     <small>Type</small>
//                     {/* Display 'Advertisement' if it matches, otherwise original */}
//                     <span>{getDisplayProductionType(candidate.productionType)}</span>
//                   </div>
//                   <button className="view-btn">
//                     View Profile <ChevronDown size={16} />
//                   </button>
//                 </div>
//               </div>
//             ))
//           )}
          
//           {visibleCount < filteredCandidates.length && (
//             <div className="loading-indicator">Loading more profiles...</div>
//           )}
//         </main>
//       </div>

//       {/* MODAL POPUP */}
//       {selectedCandidate && (
//         <div className="modal-overlay" onClick={closeCandidateModal}>
//           <div className="modal-content" onClick={e => e.stopPropagation()}>
//             <button className="close-btn" onClick={closeCandidateModal}><X size={24}/></button>
            
//             <div className="modal-header">
//               <h2>{selectedCandidate.fullName}</h2>
//               <p>{selectedCandidate.category} • {selectedCandidate.city}</p>
//             </div>

//             <div className="modal-body">
              
//               {/* Image Slider */}
//               {selectedCandidate.images.length > 0 ? (
//                 <div className="image-slider-container">
//                     <img 
//                         src={selectedCandidate.images[modalImageIndex]} 
//                         alt={`${selectedCandidate.fullName} ${modalImageIndex + 1}`} 
//                         className="modal-main-image"
//                     />
//                     {selectedCandidate.images.length > 1 && (
//                         <>
//                             <button className="slider-btn prev-btn" onClick={() => navigateModalImages(-1)}>
//                                 <ArrowLeft size={24} />
//                             </button>
//                             <button className="slider-btn next-btn" onClick={() => navigateModalImages(1)}>
//                                 <ArrowRight size={24} />
//                             </button>
//                             <div className="image-thumbnails">
//                                 {selectedCandidate.images.map((img, idx) => (
//                                     <img 
//                                         key={idx} 
//                                         src={img} 
//                                         alt={`Thumbnail ${idx}`} 
//                                         className={idx === modalImageIndex ? 'active' : ''}
//                                         onClick={() => setModalImageIndex(idx)}
//                                     />
//                                 ))}
//                             </div>
//                         </>
//                     )}
//                 </div>
//               ) : (
//                 <div className="no-image-placeholder">No Images Available</div>
//               )}

//               <div className="modal-details">
//                 {/* BASIC INFO GRID */}
//                 <div className="detail-grid">
//                     <div className="detail-row"><strong>Gender:</strong> {selectedCandidate.gender}</div>
//                     <div className="detail-row"><strong>Age:</strong> {selectedCandidate.age}</div>
//                     <div className="detail-row"><strong>Experience:</strong> {selectedCandidate.experience}</div>
//                     <div className="detail-row"><strong>Contact:</strong> {selectedCandidate.contactNo}</div>
//                     <div className="detail-row"><strong>Email:</strong> {selectedCandidate.email}</div>
//                     <div className="detail-row"><strong>Category:</strong> {selectedCandidate.category}</div>
//                 </div>
                
//                 {/* PROJECT DETAILS */}
//                 <div className="detail-block">
//                     <h4><Layers size={16} style={{marginRight: '5px'}}/> Project Details</h4>
//                     <div className="detail-row"><strong>Title/Project:</strong> {selectedCandidate.title || 'N/A'}</div>
//                     <div className="detail-row"><strong>Production Type:</strong> {getDisplayProductionType(selectedCandidate.productionType)}</div>
//                 </div>

//                 {/* ROLE DESCRIPTION */}
//                 <div className="detail-block full">
//                   <h4>Role Description:</h4>
//                   <p>{selectedCandidate.roleDescription}</p>
//                 </div>
                
//                 {/* PAST PROJECTS */}
//                 <div className="detail-block full">
//                     <h4>Past Projects</h4>
//                     <p>{selectedCandidate.pastProjects || 'No past projects listed.'}</p>
//                 </div>
                
//                 {/* DETAILED EXPERIENCE */}
//                 <div className="detail-block full">
//                     <h4>Detailed Experience / Training</h4>
//                     <p>{selectedCandidate.pastExperience || 'No detailed experience/training provided.'}</p>
//                 </div>

//                 {/* NEW: OTHER DETAILS SECTION */}
//                 {selectedCandidate.otherDetails && (
//                   <div className="detail-block full">
//                       <h4><FileText size={16} style={{marginRight: '5px'}}/> Additional Information</h4>
//                       <p>{selectedCandidate.otherDetails}</p>
//                   </div>
//                 )}

//                 {/* SOCIAL MEDIA LINKS */}
//                 {selectedCandidate.socialMedia && selectedCandidate.socialMedia.length > 0 && (
//                     <div className="detail-block full">
//                         <h4><Rss size={16} style={{marginRight: '5px'}}/> Social Media / Links</h4>
//                         <ul className="social-links-list">
//                             {selectedCandidate.socialMedia.map((social, index) => (
//                                 <li key={index} className="social-link-item">
//                                     <strong>{social.platform}:</strong> 
//                                     <a href={social.handle} target="_blank" rel="noreferrer">{social.handle}</a>
//                                 </li>
//                             ))}
//                         </ul>
//                     </div>
//                 )}
                
//                 {/* YOUTUBE LINK */}
//                 {selectedCandidate.youtubeLink && (
//                   <a href={selectedCandidate.youtubeLink} target="_blank" rel="noreferrer" className="youtube-btn">
//                     <Video size={18} /> Watch Audition Tape
//                   </a>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// import React, { useState, useEffect, useMemo } from 'react';
// import { MapPin, User, Video, Filter, X, ChevronDown, Star, ArrowLeft, ArrowRight, Rss, Layers, FileText } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import './AuditionDashbord.css';

// // List of cities to show explicitly. All others go to "Other"
// const MAIN_CITIES = [
//   'Mumbai', 'Pune', 'Delhi', 'Bangalore', 
//   'Nagpur', 'Nashik', 'Ahilyanagar', 'Sambhajinagar', 'Thane'
// ];

// // Production Types
// const MAIN_PRODUCTION_TYPES = [
//   'Film', 
//   'Advertisement', 
//   'Web Series', 
//   'Theatre', 
//   'Short Film'
// ];

// export default function AuditionDashboard() {
//   const navigate = useNavigate();

//   // --- 1. STATE MANAGEMENT ---
//   const [candidates, setCandidates] = useState([]); 
//   const [visibleCount, setVisibleCount] = useState(20); 
//   const [selectedCandidate, setSelectedCandidate] = useState(null); 
//   const [modalImageIndex, setModalImageIndex] = useState(0);
//   const [filters, setFilters] = useState({
//     categories: [],
//     genders: [], 
//     productionTypes: [], 
//     cities: [],
//     ageMin: 0,
//     ageMax: 60
//   });
//   const [userRole, setUserRole] = useState('');

//   // --- 2. READ ROLE FROM LOCALSTORAGE ---
//   useEffect(() => {
//     const role = localStorage.getItem('userRole') || '';
//     setUserRole(role);
//   }, []);

//   // --- 3. FETCH CANDIDATES ---
//   useEffect(() => {
//     const fetchCandidates = async () => {
//       try {
//         const API_URL = "https://fs1w4qkflb.execute-api.ap-south-1.amazonaws.com/proud/accessaudtions";
//         const S3_BASE_URL = "https://auditionsww.s3.ap-south-1.amazonaws.com/";

//         const response = await fetch(API_URL);
//         const data = await response.json();

//         const formattedData = data.map(item => ({
//           id: item.auditionId,
//           fullName: item.fullName,
//           age: Number(item.age),
//           gender: item.gender || 'Not Specified',
//           category: item.category,
//           productionType: item.productionType, 
//           city: item.city,
//           experience: item.experience,
//           roleDescription: item.roleDescription,
//           contactNo: item.contactNo,
//           email: item.email,
//           youtubeLink: item.youtubeLink,
//           title: item.title, 
//           pastExperience: item.pastExperience, 
//           pastProjects: item.pastProjects,
//           otherDetails: item.otherDetails || '', 
//           socialMedia: item.socialMedia || [], 
//           images: item.images ? item.images.map(key => S3_BASE_URL + key) : []
//         }));

//         setCandidates(formattedData);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchCandidates();
//   }, []);

//   // --- 4. HELPERS ---
//   const getDisplayCity = (city) => {
//     if (!city || typeof city !== 'string') return 'Other';
//     return MAIN_CITIES.includes(city.trim()) ? city.trim() : 'Other';
//   };

//   const getDisplayProductionType = (type) => {
//     if (!type || typeof type !== 'string') return 'Other';
//     const lowerType = type.toLowerCase();
//     if (lowerType.includes('commercial') || lowerType.includes('ad')) return 'Advertisement';
//     if (lowerType.includes('web series')) return 'Web Series';
//     if (lowerType.includes('short film') || lowerType.includes('short')) return 'Short Film';
//     if (lowerType.includes('film')) return 'Film';
//     if (lowerType.includes('theatre')) return 'Theatre';
//     return 'Other';
//   };

//   // --- 5. FILTERING ---
//   const filteredCandidates = useMemo(() => {
//     return candidates.filter(candidate => {
//       if (candidate.age < filters.ageMin || candidate.age > filters.ageMax) return false;
//       if (filters.genders.length > 0 && !filters.genders.includes(candidate.gender)) return false;
//       if (filters.categories.length > 0 && !filters.categories.includes(candidate.category)) return false;
//       if (filters.productionTypes.length > 0) {
//         if (!filters.productionTypes.includes(getDisplayProductionType(candidate.productionType))) return false;
//       }
//       if (filters.cities.length > 0) {
//         if (!filters.cities.includes(getDisplayCity(candidate.city))) return false;
//       }
//       return true;
//     });
//   }, [candidates, filters]);

//   // --- 6. LAZY LOADING ---
//   const handleScroll = () => {
//     if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
//       setVisibleCount(prev => Math.min(prev + 20, filteredCandidates.length));
//     }
//   };

//   useEffect(() => {
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, [filteredCandidates]);

//   // --- 7. FILTER HANDLERS ---
//   const toggleFilter = (type, value) => {
//     setFilters(prev => {
//       const list = prev[type];
//       const newList = list.includes(value) 
//         ? list.filter(item => item !== value)
//         : [...list, value];
//       setVisibleCount(20);
//       return { ...prev, [type]: newList };
//     });
//   };

//   const openCandidateModal = (candidate, initialImageIndex = 0) => {
//     setSelectedCandidate(candidate);
//     setModalImageIndex(initialImageIndex);
//   };

//   const closeCandidateModal = () => setSelectedCandidate(null);

//   const navigateModalImages = (direction) => {
//     const imagesCount = selectedCandidate.images.length;
//     setModalImageIndex(prevIndex => {
//       let newIndex = prevIndex + direction;
//       if (newIndex < 0) newIndex = imagesCount - 1;
//       if (newIndex >= imagesCount) newIndex = 0;
//       return newIndex;
//     });
//   };

//   // --- 8. REUSABLE CHECKBOX ---
//   const CheckboxGroup = ({ title, options, type, currentSelected, countAccessor }) => (
//     <div className="filter-group">
//       <h4>{title}</h4>
//       {options.map(opt => {
//         const count = candidates.filter(c => countAccessor(c) === opt).length;
//         return (
//           <label key={opt} className="checkbox-label">
//             <input 
//               type="checkbox" 
//               checked={currentSelected.includes(opt)}
//               onChange={() => toggleFilter(type, opt)}
//             />
//             <span>{opt}</span>
//             <span className="count">({count})</span>
//           </label>
//         );
//       })}
//     </div>
//   );

//   // --- 9. RENDER ---
//   return (
//     <div className="dashboard-container">
//       {/* HEADER */}
//       <header className="dashboard-header">
//         <div className="header-content">
//           <h1>Audition Talent Pool</h1>
//           <p>{filteredCandidates.length} profiles found matching your criteria</p>
//         </div>
//         {/* ADMIN ONLY: Manage Users */}
//         {userRole === 'ADMIN' && (
//           <div className="header-actions">
//             <button className="manage-users-btn" onClick={() => navigate('/ManageUsers')}>
//               Manage Users
//             </button>
//           </div>
//         )}
//       </header>

//       <div className="layout-grid">
//         {/* LEFT SIDEBAR: FILTERS */}
//         <aside className="sidebar">
//           <div className="filter-card">
//             <div className="filter-header">
//               <h3><Filter size={18} /> Filter by:</h3>
//             </div>

//             {/* Age Range */}
//             <div className="filter-group">
//               <h4>Age Range</h4>
//               <div className="range-inputs">
//                 <input 
//                   type="number" 
//                   value={filters.ageMin} 
//                   onChange={(e) => setFilters(prev => ({...prev, ageMin: Number(e.target.value)}))}
//                   placeholder="Min"
//                   min="1"
//                   max="100"
//                 />
//                 <span>-</span>
//                 <input 
//                   type="number" 
//                   value={filters.ageMax} 
//                   onChange={(e) => setFilters(prev => ({...prev, ageMax: Number(e.target.value)}))}
//                   placeholder="Max"
//                   min="1"
//                   max="100"
//                 />
//               </div>
//             </div>

//             {/* Gender */}
//             <CheckboxGroup 
//               title="Gender" 
//               options={['Male', 'Female', 'Other', 'Not Specified']} 
//               type="genders"
//               currentSelected={filters.genders}
//               countAccessor={(c) => c.gender}
//             />

//             {/* Category */}
//             <CheckboxGroup 
//               title="Category" 
//               options={['Actor', 'Model', 'Dancer', 'Singer', 'Voice Artist','Other']} 
//               type="categories"
//               currentSelected={filters.categories}
//               countAccessor={(c) => c.category}
//             />

//             {/* City */}
//             <CheckboxGroup 
//               title="Current City" 
//               options={[...MAIN_CITIES, 'Other']} 
//               type="cities"
//               currentSelected={filters.cities}
//               countAccessor={(c) => getDisplayCity(c.city)}
//             />

//             {/* Production Type */}
//             <CheckboxGroup 
//               title="Production Type" 
//               options={[...MAIN_PRODUCTION_TYPES, 'Other']} 
//               type="productionTypes"
//               currentSelected={filters.productionTypes}
//               countAccessor={(c) => getDisplayProductionType(c.productionType)}
//             />

//           </div>
//         </aside>

//         {/* MAIN CONTENT: CANDIDATE CARDS */}
//         <main className="results-area">
//           {filteredCandidates.length === 0 ? (
//             <div className="no-results">
//               <h3>No candidates found.</h3>
//               <p>Try adjusting your filters.</p>
//             </div>
//           ) : (
//             filteredCandidates.slice(0, visibleCount).map(candidate => (
//               <div key={candidate.id} className="candidate-card" onClick={() => openCandidateModal(candidate)}>
//                 <div className="card-image-wrapper">
//                   <img 
//                     src={candidate.images[0] || "https://via.placeholder.com/200?text=No+Image"} 
//                     alt={candidate.fullName} 
//                   />
//                 </div>
//                 <div className="card-info">
//                   <div className="card-header">
//                     <h2>{candidate.fullName}</h2>
//                     <span className={`badge ${candidate.category.toLowerCase().replace(/\s/g, '-')}`}>{candidate.category}</span>
//                   </div>
//                   <div className="card-meta">
//                     <span className="meta-item"><User size={16} /> {candidate.age} yrs ({candidate.gender})</span>
//                     <span className="meta-item"><MapPin size={16} /> {candidate.city}</span>
//                     <span className="meta-item"><Star size={16} /> Exp: {candidate.experience}</span>
//                   </div>
//                   <p className="card-desc">
//                     {candidate.roleDescription 
//                       ? candidate.roleDescription.substring(0, 100) + (candidate.roleDescription.length > 100 ? "..." : "") 
//                       : "No description provided."}
//                   </p>
//                 </div>
//                 <div className="card-actions">
//                   <div className="price-dummy">
//                     <small>Type</small>
//                     <span>{getDisplayProductionType(candidate.productionType)}</span>
//                   </div>
//                   <button className="view-btn">
//                     View Profile <ChevronDown size={16} />
//                   </button>
//                 </div>
//               </div>
//             ))
//           )}
//           {visibleCount < filteredCandidates.length && (
//             <div className="loading-indicator">Loading more profiles...</div>
//           )}
//         </main>
//       </div>

//       {/* MODAL */}
//       {selectedCandidate && (
//         <div className="modal-overlay" onClick={closeCandidateModal}>
//           <div className="modal-content" onClick={e => e.stopPropagation()}>
//             <button className="close-btn" onClick={closeCandidateModal}><X size={24}/></button>
//             <div className="modal-header">
//               <h2>{selectedCandidate.fullName}</h2>
//               <p>{selectedCandidate.category} • {selectedCandidate.city}</p>
//             </div>

//             <div className="modal-body">
//               {/* IMAGE SLIDER */}
//               {selectedCandidate.images.length > 0 ? (
//                 <div className="image-slider-container">
//                     <img 
//                         src={selectedCandidate.images[modalImageIndex]} 
//                         alt={`${selectedCandidate.fullName} ${modalImageIndex + 1}`} 
//                         className="modal-main-image"
//                     />
//                     {selectedCandidate.images.length > 1 && (
//                         <>
//                             <button className="slider-btn prev-btn" onClick={() => navigateModalImages(-1)}>
//                                 <ArrowLeft size={24} />
//                             </button>
//                             <button className="slider-btn next-btn" onClick={() => navigateModalImages(1)}>
//                                 <ArrowRight size={24} />
//                             </button>
//                             <div className="image-thumbnails">
//                                 {selectedCandidate.images.map((img, idx) => (
//                                     <img 
//                                         key={idx} 
//                                         src={img} 
//                                         alt={`Thumbnail ${idx}`} 
//                                         className={idx === modalImageIndex ? 'active' : ''}
//                                         onClick={() => setModalImageIndex(idx)}
//                                     />
//                                 ))}
//                             </div>
//                         </>
//                     )}
//                 </div>
//               ) : (
//                 <div className="no-image-placeholder">No Images Available</div>
//               )}

//               <div className="modal-details">
//                 <div className="detail-grid">
//                     <div className="detail-row"><strong>Gender:</strong> {selectedCandidate.gender}</div>
//                     <div className="detail-row"><strong>Age:</strong> {selectedCandidate.age}</div>
//                     <div className="detail-row"><strong>Experience:</strong> {selectedCandidate.experience}</div>
//                     <div className="detail-row"><strong>Contact:</strong> {selectedCandidate.contactNo}</div>
//                     <div className="detail-row"><strong>Email:</strong> {selectedCandidate.email}</div>
//                     <div className="detail-row"><strong>Category:</strong> {selectedCandidate.category}</div>
//                 </div>
                
//                 <div className="detail-block">
//                     <h4><Layers size={16} style={{marginRight: '5px'}}/> Project Details</h4>
//                     <div className="detail-row"><strong>Title/Project:</strong> {selectedCandidate.title || 'N/A'}</div>
//                     <div className="detail-row"><strong>Production Type:</strong> {getDisplayProductionType(selectedCandidate.productionType)}</div>
//                 </div>

//                 <div className="detail-block full">
//                   <h4>Role Description:</h4>
//                   <p>{selectedCandidate.roleDescription}</p>
//                 </div>
                
//                 <div className="detail-block full">
//                     <h4>Past Projects</h4>
//                     <p>{selectedCandidate.pastProjects || 'No past projects listed.'}</p>
//                 </div>
                
//                 <div className="detail-block full">
//                     <h4>Detailed Experience / Training</h4>
//                     <p>{selectedCandidate.pastExperience || 'No detailed experience/training provided.'}</p>
//                 </div>

//                 {selectedCandidate.otherDetails && (
//                   <div className="detail-block full">
//                       <h4><FileText size={16} style={{marginRight: '5px'}}/> Additional Information</h4>
//                       <p>{selectedCandidate.otherDetails}</p>
//                   </div>
//                 )}

//                 {selectedCandidate.socialMedia && selectedCandidate.socialMedia.length > 0 && (
//                     <div className="detail-block full">
//                         <h4><Rss size={16} style={{marginRight: '5px'}}/> Social Media / Links</h4>
//                         <ul className="social-links-list">
//                             {selectedCandidate.socialMedia.map((social, index) => (
//                                 <li key={index} className="social-link-item">
//                                     <strong>{social.platform}:</strong> 
//                                     <a href={social.handle} target="_blank" rel="noreferrer">{social.handle}</a>
//                                 </li>
//                             ))}
//                         </ul>
//                     </div>
//                 )}
                
//                 {selectedCandidate.youtubeLink && (
//                   <a href={selectedCandidate.youtubeLink} target="_blank" rel="noreferrer" className="youtube-btn">
//                     <Video size={18} /> Watch Audition Tape
//                   </a>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }



//Updated On 18 Dec
import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  MapPin, User, Video, Filter, X, ChevronDown, 
  Star, ArrowLeft, ArrowRight, Rss, Layers, 
  FileText, Settings, Search, Info, RotateCcw,
  Mail, Phone, ExternalLink
} from 'lucide-react';
import './AuditionDashbord.css';

const MAIN_CITIES = ['Mumbai', 'Pune', 'Delhi', 'Bangalore', 'Nagpur', 'Nashik', 'Ahilyanagar', 'Sambhajinagar', 'Thane'];
const MAIN_PRODUCTION_TYPES = ['Film', 'Advertisement', 'Web Series', 'Theatre', 'Short Film'];

export default function AuditionDashboard() {
  const navigate = useNavigate();
  
  // --- State ---
  const [candidates, setCandidates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(12);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [modalImageIndex, setModalImageIndex] = useState(0);
  const [userRole, setUserRole] = useState('');
  
  const [filters, setFilters] = useState({
    categories: [],
    genders: [],
    productionTypes: [],
    cities: [],
    ageMin: 0,
    ageMax: 100,
    searchQuery: ''
  });

  // --- Data Normalization Helpers ---
  const getDisplayCity = (city) => (MAIN_CITIES.includes(city?.trim()) ? city.trim() : 'Other');
  
  const getDisplayProductionType = (type) => {
    const t = type?.toLowerCase() || '';
    if (t.includes('commercial') || t.includes('ad')) return 'Advertisement';
    if (t.includes('web')) return 'Web Series';
    if (t.includes('short')) return 'Short Film';
    if (t.includes('theatre')) return 'Theatre';
    return t.includes('film') ? 'Film' : 'Other';
  };

  // --- Initial Load ---
  useEffect(() => {
    setUserRole(localStorage.getItem('userRole') || '');
    const fetchCandidates = async () => {
      try {
        const API_URL = "https://fs1w4qkflb.execute-api.ap-south-1.amazonaws.com/proud/accessaudtions";
        const S3_BASE_URL = "https://auditionsww.s3.ap-south-1.amazonaws.com/";
        const response = await fetch(API_URL);
        const data = await response.json();

        const formattedData = data.map(item => ({
          ...item,
          id: item.auditionId,
          age: Number(item.age),
          images: item.images ? item.images.map(key => S3_BASE_URL + key) : []
        }));

        setCandidates(formattedData);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCandidates();
  }, []);

  // --- Dynamic Count Logic ---
  const counts = useMemo(() => {
    const stats = { categories: {}, genders: {}, cities: {}, productionTypes: {} };
    candidates.forEach(c => {
      stats.categories[c.category] = (stats.categories[c.category] || 0) + 1;
      stats.genders[c.gender] = (stats.genders[c.gender] || 0) + 1;
      
      const cityLabel = getDisplayCity(c.city);
      stats.cities[cityLabel] = (stats.cities[cityLabel] || 0) + 1;
      
      const prodLabel = getDisplayProductionType(c.productionType);
      stats.productionTypes[prodLabel] = (stats.productionTypes[prodLabel] || 0) + 1;
    });
    return stats;
  }, [candidates]);

  // --- Filtering Logic ---
  const filteredCandidates = useMemo(() => {
    return candidates.filter(c => {
      const matchesSearch = c.fullName.toLowerCase().includes(filters.searchQuery.toLowerCase());
      const matchesAge = c.age >= filters.ageMin && c.age <= filters.ageMax;
      const matchesGender = filters.genders.length === 0 || filters.genders.includes(c.gender);
      const matchesCat = filters.categories.length === 0 || filters.categories.includes(c.category);
      const matchesCity = filters.cities.length === 0 || filters.cities.includes(getDisplayCity(c.city));
      const matchesProd = filters.productionTypes.length === 0 || filters.productionTypes.includes(getDisplayProductionType(c.productionType));
      return matchesSearch && matchesAge && matchesGender && matchesCat && matchesCity && matchesProd;
    });
  }, [candidates, filters]);

  // --- Event Handlers ---
  const toggleFilter = (type, value) => {
    setFilters(prev => ({
      ...prev,
      [type]: prev[type].includes(value) ? prev[type].filter(i => i !== value) : [...prev[type], value]
    }));
    setVisibleCount(12);
  };

  const handleReset = () => {
    setFilters({categories:[], genders:[], productionTypes:[], cities:[], ageMin:0, ageMax:100, searchQuery:''});
  };

  const navigateModalImages = (e, direction) => {
    e.stopPropagation();
    const len = selectedCandidate.images.length;
    setModalImageIndex(prev => (prev + direction + len) % len);
  };

  return (
    <div className="talent-dashboard-env">
      {/* Top Navigation */}
      <nav className="top-nav">
        <div className="nav-container">
          <div className="brand" onClick={() => window.location.reload()}>
            <div className="logo-icon">A</div>
            <div>
              <h1>AuditionHub</h1>
              <span>Talent Acquisition Portal</span>
            </div>
          </div>
          
          <div className="search-bar">
            <Search size={18} />
            <input 
              type="text" 
              placeholder="Search by talent name..." 
              value={filters.searchQuery}
              onChange={(e) => setFilters(f => ({...f, searchQuery: e.target.value}))}
            />
          </div>

          {userRole === 'ADMIN' && (
            <button className="admin-link" onClick={() => navigate('/ManageUsers')}>
              <Settings size={18} />
              <span>Admin Panel</span>
            </button>
          )}
        </div>
      </nav>

      <div className="dashboard-content">
        {/* Sidebar Filters */}
        <aside className="filter-sidebar">
          <div className="filter-card">
            <div className="filter-section-head">
              <span className="head-title"><Filter size={16} /> Filters</span>
              <button className="clear-btn" onClick={handleReset}>
                <RotateCcw size={12} /> Reset
              </button>
            </div>

            <div className="filter-group">
              <label>Age Range</label>
              <div className="age-inputs">
                <input type="number" value={filters.ageMin} onChange={e => setFilters(f => ({...f, ageMin: +e.target.value}))} placeholder="0" />
                <span>-</span>
                <input type="number" value={filters.ageMax} onChange={e => setFilters(f => ({...f, ageMax: +e.target.value}))} placeholder="100" />
              </div>
            </div>

            <FilterCheckboxSection 
              title="Talent Category" 
              options={['Actor', 'Model', 'Dancer', 'Singer', 'Voice Artist']} 
              selected={filters.categories} 
              onToggle={(v) => toggleFilter('categories', v)}
              counts={counts.categories}
            />

            <FilterCheckboxSection 
              title="Gender" 
              options={['Male', 'Female', 'Other', 'Not Specified']} 
              selected={filters.genders} 
              onToggle={(v) => toggleFilter('genders', v)}
              counts={counts.genders}
            />

            <FilterCheckboxSection 
              title="Location" 
              options={[...MAIN_CITIES, 'Other']} 
              selected={filters.cities} 
              onToggle={(v) => toggleFilter('cities', v)}
              counts={counts.cities}
            />

            <FilterCheckboxSection 
              title="Production Type" 
              options={[...MAIN_PRODUCTION_TYPES, 'Other']} 
              selected={filters.productionTypes} 
              onToggle={(v) => toggleFilter('productionTypes', v)}
              counts={counts.productionTypes}
            />
          </div>
        </aside>

        {/* Main Talent Feed */}
        <main className="talent-feed">
          <div className="feed-header">
            Showing <strong>{filteredCandidates.length}</strong> matching profiles
          </div>

          {isLoading ? (
            <div className="skeleton-grid">
              {[1,2,3,4,5,6].map(i => <div key={i} className="skeleton-card" />)}
            </div>
          ) : (
            <>
              {filteredCandidates.length === 0 ? (
                <div className="no-results-state">
                   <Info size={48} />
                   <h3>No candidates found</h3>
                   <p>Try clearing your filters or changing your search term.</p>
                </div>
              ) : (
                <div className="talent-grid">
                  {filteredCandidates.slice(0, visibleCount).map(candidate => (
                    <div key={candidate.id} className="talent-card" onClick={() => { setSelectedCandidate(candidate); setModalImageIndex(0); }}>
                      <div className="talent-thumb">
                        <img src={candidate.images[0] || "https://via.placeholder.com/300?text=No+Photo"} alt={candidate.fullName} />
                        <span className="type-tag">{getDisplayProductionType(candidate.productionType)}</span>
                      </div>
                      <div className="talent-info">
                        <h3>{candidate.fullName}</h3>
                        <p className="category-label">{candidate.category}</p>
                        <div className="meta">
                          <span><User size={14}/> {candidate.age} yrs • {candidate.gender}</span>
                          <span><MapPin size={14}/> {candidate.city}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          {!isLoading && filteredCandidates.length > visibleCount && (
            <div className="load-more-container">
               <button className="load-more" onClick={() => setVisibleCount(v => v + 12)}>Load More Talent</button>
            </div>
          )}
        </main>
      </div>

      {/* Profile Detail Modal */}
      {selectedCandidate && (
        <div className="prof-modal-overlay" onClick={() => setSelectedCandidate(null)}>
          <div className="prof-modal-container" onClick={e => e.stopPropagation()}>
            <button className="prof-close" onClick={() => setSelectedCandidate(null)}><X /></button>
            
            <div className="prof-modal-layout">
              {/* Left Side: Images */}
              <div className="prof-gallery-side">
                <div className="main-img-wrapper">
                  <img src={selectedCandidate.images[modalImageIndex]} alt="Talent profile" />
                  {selectedCandidate.images.length > 1 && (
                    <div className="nav-arrows">
                      <button onClick={(e) => navigateModalImages(e, -1)}><ArrowLeft size={20}/></button>
                      <button onClick={(e) => navigateModalImages(e, 1)}><ArrowRight size={20}/></button>
                    </div>
                  )}
                </div>
                <div className="thumb-strip">
                  {selectedCandidate.images.map((img, i) => (
                    <img key={i} src={img} className={i === modalImageIndex ? 'active' : ''} onClick={() => setModalImageIndex(i)} />
                  ))}
                </div>
              </div>

              {/* Right Side: Information */}
              <div className="prof-details-side">
                <div className="prof-header">
                  <h2>{selectedCandidate.fullName}</h2>
                  <span className="status-badge">Professional</span>
                </div>

                <div className="info-grid">
                  <div className="info-item"><small>Category</small><p>{selectedCandidate.category}</p></div>
                  <div className="info-item"><small>Experience</small><p>{selectedCandidate.experience}</p></div>
                  <div className="info-item"><small>City</small><p>{selectedCandidate.city}</p></div>
                  <div className="info-item"><small>Age/Gender</small><p>{selectedCandidate.age} / {selectedCandidate.gender}</p></div>
                </div>

                <div className="prof-section">
                  <h4><FileText size={16}/> Role Description</h4>
                  <p>{selectedCandidate.roleDescription || "No role details provided."}</p>
                </div>

                <div className="prof-section">
                  <h4><Layers size={16}/> Notable Projects</h4>
                  <p>{selectedCandidate.pastProjects || "No past projects listed."}</p>
                </div>

                {selectedCandidate.otherDetails && (
                  <div className="prof-section">
                    <h4><Info size={16}/> Additional Details</h4>
                    <p>{selectedCandidate.otherDetails}</p>
                  </div>
                )}

                <div className="contact-footer">
                  <div className="contact-methods">
                    <div><Mail size={14}/> {selectedCandidate.email}</div>
                    <div><Phone size={14}/> {selectedCandidate.contactNo}</div>
                  </div>
                  {selectedCandidate.youtubeLink && (
                    <a href={selectedCandidate.youtubeLink} target="_blank" rel="noreferrer" className="action-btn yt">
                      <Video size={18} /> View Showreel
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// --- Helper Component: Filter Sections ---
const FilterCheckboxSection = ({ title, options, selected, onToggle, counts }) => (
  <div className="filter-group">
    <label>{title}</label>
    {options.map(opt => {
      const count = counts[opt] || 0;
      return (
        <div key={opt} className={`check-row ${count === 0 ? 'empty-opt' : ''}`} onClick={() => onToggle(opt)}>
          <div className={`custom-check ${selected.includes(opt) ? 'checked' : ''}`} />
          <span className="opt-name">{opt}</span>
          <span className="opt-count">{count}</span>
        </div>
      );
    })}
  </div>
);